
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { mobileRulesEl, usernameRuleEl, mailRulesEl } from "@common/src/utils/verify";
import t from "@common/src/i18n/t";
const staff = namespace("staff");
const setting = namespace("setting");
const store = namespace("store");
const user = namespace("user");
const app = namespace("app");
const common_app = namespace("common_app");
const base = namespace("base");
@Component({})
export default class StaffEdit extends Vue {
  @staff.Action createStaff;
  @staff.Action updateStaff;
  @setting.Action getRoleList;
  @store.Action getStoreList;
  @store.State storeList;
  @store.State storeData;
  @user.State userData;
  @staff.Action getStaffDetail;
  @staff.Action resetStaffPassword;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @base.Action getDictionaryList;
  @common_app.State country;
  get breadData() {
    return [
      { name: t("setting.employee-information-list"), path: "/setting/staff" },
      { name: this.isAdd ? t("staff.add-employee") : t("setting.edit-employee-information") }
    ];
  }
  staffFormData = {
    staffName: "",
    account: "",
    mobile: "",
    email: "",
    gender: "",
    roleCodeList: [],
    orgCodeList: [],
    status: "1",
    roleList: [],
    storeList: [],
    staffLevel: "",
    userCode: ""
  };
  showEditStaff: boolean = false;
  roleList: any[] = [];
  staffFormRules = {
    staffName: [{ required: true, message: t("setting.enter-employee-name"), trigger: "blur" }],
    mobile: [
      { required: true, message: t("setting.employee-cell-phone-number"), trigger: "blur" },
      { validator: this.validateMobile, trigger: "blur" }
    ],
    email: [
      { required: true, message: t("base.please-enter-field", [t("setting.mailbox")]), trigger: "blur" },
      { validator: (rule, value, callback) => mailRulesEl(value, callback), trigger: "blur" }
    ],
    account: [
      { required: true, message: t("setting.enter-user-name"), trigger: "blur" },
      { validator: this.validatUsername, trigger: "blur" }
    ],
    gender: [{ required: true, message: t("setting.select-employee-gender"), trigger: "change" }],
    roleCodeList: [
      {
        type: "array",
        required: true,
        message: t("setting.select-employee-roles"),
        trigger: "change"
      }
    ],

    orgCodeList: [
      {
        type: "array",
        required: true,
        message: t("setting.select-employee-stores"),
        trigger: "change"
      }
    ],
    status: [{ required: true, message: t("setting.select-whether-enable"), trigger: "change" }]
  };
  get isAdd() {
    return this.$route.name === "staffAdd";
  }
  get isShowResetBtn() {
    return this.userData.roleList.some(item => {
      return item.roleCode.includes("admin");
    });
  }
  existStaffCode: string = "";
  async queryUser() {
    if (!this.isAdd) return;
    if (this.staffFormData.mobile) {
      try {
        const staffData = await this.getStaffDetail({
          mobile: this.staffFormData.mobile
        });
        this.existStaffCode = staffData.data.userCode;
        this.showEditStaff = true;
      } catch (e) {
        console.log(e);
      }
    }
  }
  linkEditStaff() {
    if (this.existStaffCode) {
      this.$router.push(`/setting/staff-edit/${this.existStaffCode}?type=1`);
    }
  }

  created() {
    this.init();
  }
  validateMobile(rule, value, callback) {
    mobileRulesEl(value, callback);
  }
  validatUsername(rule, value, callback) {
    usernameRuleEl(value, callback);
  }
  submitForm() {
    (this.$refs["staffForm"] as any).validate(valid => {
      if (valid) {
        this.btnStartLoading();
        if (this.isAdd) {
          this.addStaff();
        } else {
          this.editStaff();
        }
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  staffLevel = [];
  async init() {
    const data = await this.getDictionaryList("staff_level");
    this.staffLevel = data;
    const roleListData = await this.getRoleList({
      pageNum: 1,
      pageSize: 100
    });
    if (!this.isAdd) {
      try {
        const staffData = await this.getStaffDetail({
          userCode: this.$route.params.id
        });
        staffData.data.roleCodeList = staffData.data.roleList ? staffData.data.roleList.map(item => item.roleCode) : [];
        staffData.data.orgCodeList = staffData.data.storeList ? staffData.data.storeList.map(item => item.orgCode) : [];
        this.staffFormData = staffData.data;
        this.staffFormData.staffLevel = String(staffData.data.staffLevel || "");
      } catch (e) {
        console.log(e);
        // this.$message.error(e.message);
      }
    } else {
      this.staffFormData.orgCodeList = [this.storeData.orgCode];
    }
    this.roleList = roleListData.data.list;
  }

  async addStaff() {
    this.createStaff(this.staffFormData)
      .then(() => {
        this.$message.success(t("base.success") as any);
        this.$router.push(`/setting/staff`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  async editStaff(type = "edit") {
    (this.staffFormData as any).userCode = this.$route.params.id;
    return this.updateStaff(this.staffFormData)
      .then(() => {
        if (type === "edit") {
          this.$message.success(t("base.success") as any);
          this.$router.push(`/setting/staff`);
        }
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  async handleResetPwd() {
    (this.$refs["staffForm"] as any).validate(async valid => {
      if (valid) {
        this.btnStartLoading();
        await this.editStaff("reset");
        this.resetStaffPassword({ userCode: (this.staffFormData as any).userCode }).then(
          () => {
            this.$message.success(t("v216_g.staff-reset-pwd-eamil-send-tips"));
          },
          data => {
            this.$alert(data.message, t("v210831.tips"), {
              confirmButtonText: t("v210831.determine")
            });
          }
        );
      }
    });
  }
}
